import { useStockLocation } from '../hooks/useStockLocation'
import StockLocationIndex from '../components/stockLocation/StockLocationIndex'
import ModalFormStockLocation from '../components/stockLocation/ModalFormStockLocation'

export default function StockLocation() {
  const stockLocationHook = useStockLocation()

  return (
    <div className="content-wrapper">
      {stockLocationHook.toastContainer}
      <StockLocationIndex
        isLoadingStockLocations={stockLocationHook.isLoadingStockLocations}
        isFailedStockLocations={stockLocationHook.isFailedStockLocations}
        statusStockLocation={stockLocationHook.statusStockLocations}
        stockLocations={stockLocationHook.stockLocations}
        totalRows={stockLocationHook.totalRowsStockLocations}
        currentPage={stockLocationHook.currentPageStockLocations}
        currentLimit={stockLocationHook.currentLimitStockLocations}
        onChangeStatusStockLocation={stockLocationHook.handleChangeStatusStockLocation}
        onOpenCreateStockLocation={stockLocationHook.handleOpenCreateFormStockLocation}
        onOpenUpdateStockLocation={stockLocationHook.handleOpenUpdateFormStockLocation}
        onChangePage={stockLocationHook.handleChangePageStockLocation}
        onChangeLimit={stockLocationHook.handleChangeLimitStockLocation}
        fetchStockLocations={stockLocationHook.fetchStockLocations}
      />
      {stockLocationHook.isOpenModalFormStockLocation ? (
        <ModalFormStockLocation
          stateForm={stockLocationHook.stateFormStockLocation}
          isLoading={stockLocationHook.isLoadingFormStockLocation}
          isOpen={stockLocationHook.isOpenModalFormStockLocation}
          initialValues={stockLocationHook.initialFormStockLocation}
          vendorInitialName={stockLocationHook.vendorInitialName}
          provinces={stockLocationHook.provincesDropdown}
          vendors={stockLocationHook.vendorsDropdown}
          isLoadingVendors={stockLocationHook.isLoadingFetchVendors}
          onChangeVendorNameDropdown={stockLocationHook.handleChangeVendorNameDropdown}
          onCancel={stockLocationHook.handleCancelFormStockLocation}
          onSubmit={stockLocationHook.handleSubmit}
          onPopUpScrollVendors={stockLocationHook.handlePopUpScrollVendors}
        />
      ) : null}
    </div>
  )
}
